import { ApplicationConfig, provideZoneChangeDetection, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LOAD_WASM } from 'ngx-scanner-qrcode';
import { provideServiceWorker } from '@angular/service-worker';

import { routes } from './app.routes';
import { AppInterceptor } from './shared/interceptors';

//guards
import { AppGuard } from './shared/guards/app.guard';

LOAD_WASM().subscribe();

const GUARDS = [
  AppGuard
]

export const appConfig: ApplicationConfig = {
  providers: [
    ...GUARDS,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true
    },
  ]
};
